import { useContext } from 'react'
import {
  ChatUnreadContextV2,
  type ChatUnreadContextV2Value,
} from '../providers/ChatUnreadProviderV2'

export const useChatUnreadV2 = (): ChatUnreadContextV2Value =>
  useContext(ChatUnreadContextV2)
